import { Link, Stack, Typography } from "@mui/material";
import { ReportIssueFAQ } from "Components/ReportIssue/ReportIssueFAQ";
import { Alert } from "Components/_Shared/Alert";
import { Flex } from "Components/_Shared/Core/Flex";
import { AuthenticatedLayout } from "Components/_Shared/Layouts/AuthenticatedLayout";
import { ANALYZER_EMAIL } from "Infrastructure/Config/constants";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const ReportIssuePage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout title={t(Resources.ReportIssue.Title)}>
      <Stack spacing={Spacing.XXXL}>
        <Stack spacing={Spacing.S}>
          <Typography variant="h2">{t(Resources.ReportIssue.Title)}</Typography>
          <Typography variant="body1" color="secondary">
            {t(Resources.ReportIssue.SubTitle)}
          </Typography>
        </Stack>
        <ReportIssueFAQ />
        <Typography variant="subtitle1" fontWeight={600}>
          {t(Resources.ReportIssue.Feedback.Prompt)}
        </Typography>
        <Flex width="100%">
          <Stack
            width="70%"
            alignItems="center"
            textAlign="center"
            spacing={Spacing.M}
            p={Spacing.XXL}
            borderRadius={Radius.M}
            border="1px solid"
            borderColor="grey.200"
            bgcolor="grey.50"
          >
            <Typography fontSize={14}>{`${t(Resources.ReportIssue.Feedback.SendEmailTo)}:`}</Typography>
            <Link href={`mailto:${ANALYZER_EMAIL}`} underline="hover" color="text.primary">
              <Typography variant="h2" fontWeight={600} color="inherit">
                {ANALYZER_EMAIL}
              </Typography>
            </Link>
            <Alert variant="info" text={t(Resources.ReportIssue.Feedback.NotForIssues)} />
          </Stack>
        </Flex>
      </Stack>
    </AuthenticatedLayout>
  );
};
